import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';

import NotificationBellPng from '../../../assets/notification-bell.png';
import { testProps } from '../../../config';
import { goldGlow } from '../../../shared/glowStyles';
import { TouchableOpacity } from '../../Components/common/Touchable';

type NotificationButtonProps = {
	unread: number;
	onPress: () => void;
};

const NotificationButton = ({ unread, onPress }: NotificationButtonProps) => {
	return (
		<TouchableOpacity style={styles.button} onPress={onPress} {...testProps('cta-nav-messages')}>
			<View style={styles.buttonInner}>
				<Image source={NotificationBellPng} style={styles.bellIcon} />
				{unread > 0 && (
					<View style={styles.badge}>
						<Text numberOfLines={1} ellipsizeMode='tail' style={styles.badgeText}>
							{unread}
						</Text>
					</View>
				)}
			</View>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	// Figma "Top Bar" / "Actions" (3618:68818): the notification and settings buttons are 44x43.
	button: {
		width: 44,
		height: 43,
		alignItems: 'center',
		justifyContent: 'center',
	},
	buttonInner: {
		width: 44,
		height: 43,
		borderRadius: 21.5,
		borderWidth: 1,
		borderColor: '#F5C747',
		backgroundColor: '#290908E0',
		alignItems: 'center',
		justifyContent: 'center',
		...goldGlow,
	},
	bellIcon: {
		width: 27,
		height: 27,
	},
	badge: {
		position: 'absolute',
		top: -4,
		right: -3,
		width: 20,
		height: 20,
		borderRadius: 10,
		borderWidth: 1,
		borderColor: '#FFFFFF',
		backgroundColor: '#ED2B2A',
		pointerEvents: 'none',
		justifyContent: 'center',
		alignItems: 'center',
	},
	badgeText: {
		color: 'white',
		fontSize: 12,
		fontWeight: '800',
		includeFontPadding: false,
		lineHeight: 12,
	},
});

export default NotificationButton;
